import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
  const profileFilter = chooseProfileFilter();

  const pathFrontEnd = '/fileaccountabilities/';
  const paths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
    endpointDelete: `${config.endpoints.backend}fileaccountabilities/delete`,
    endpoint: config.endpoints.backend + 'fileaccountabilities/getall'
  }

  let list = {
    labelTitle: 'Lista de Prestação de Contas',
    labelTitleButtonAdd: 'Importar nova pretação de contas',
    fieldsShowOnDelete: ['entity_name'],
    showPrintButtons: true,
    canEdit: false,
    filter: {
      ...profileFilter
    },
    columns: [
      {
        name: 'company_name',
        label: 'Realizado Por',
      },
      {
        name: 'created_at',
        label: 'Data',
      },
      {
        name: 'file_status',
        label: 'Status',
      }
    ],
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
      />
    </div>
  );
}
export default List;
